export class HttpError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = "HttpError";
    this.status = status;
  }
}

export async function fetchJson<T>(input: string, init?: RequestInit): Promise<T> {
  const response = await fetch(input, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(init?.headers ?? {}),
    },
    ...init,
  });

  if (!response.ok) {
    const message = await response.text();
    throw new HttpError(response.status, message || `Request failed: ${response.status}`);
  }

  return (await response.json()) as T;
}

export async function postJson<TBody>(input: string, body: TBody, init?: RequestInit): Promise<void> {
  const response = await fetch(input, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
    ...init,
    method: "POST",
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new HttpError(response.status, message || `Request failed: ${response.status}`);
  }
}
